import React, { Component } from 'react';
import { notification, Table, Modal } from 'antd';
import { PageContainer } from '@ant-design/pro-layout';
import dayjs from 'dayjs';
import dashboardService from 'services/dashboard.service';
import { formatMoney, formatDateForClient } from 'helpers/utils';
import { AuthContext } from 'context/AuthContext';
import { NavLink } from 'react-router-dom';
import 'antd/dist/reset.css';

class PayeInvoices extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      loading: false,
      currentMerch: context?.selectedMerch,
      startDate: formatDateForClient(dayjs().subtract(2, 'years')),
      endDate: formatDateForClient(),
      modalVisible: false,
      columns: [
        {
          title: <div className="table-title-calibri-bold-12">Fatura No</div>,
          dataIndex: 'InvoiceNumber',
          key: 'InvoiceNumber',
          render: (text, row) => (
            <span className="table-title-calibri-bold-12">
              {row.InvoiceNumber ? row.InvoiceNumber : ''}
            </span>
          ),
        },
        {
          title: <div className="table-title-calibri-bold-12">Kesildiği Fatura No</div>,
          dataIndex: 'RelatedInvoiceNumber',
          key: 'RelatedInvoiceNumber',
          align: 'center',
          render: (text, row) => (
            <span className="table-title-calibri-bold-12">
              {row.RelatedInvoiceNumber ? row.RelatedInvoiceNumber : ''}
            </span>
          ),
        },
        {
          title: <div className="table-title-calibri-bold-12">Fatura Tutarı</div>,
          dataIndex: 'InvoiceAmount',
          key: 'InvoiceAmount',
          align: 'center',
          render: (text, row) => (
            <span className="table-title-calibri-bold-12">
              {row.InvoiceAmount ? formatMoney(row.InvoiceAmount) : ''}
            </span>
          ),
        },
        {
          title: <div className="table-title-calibri-bold-12">Fatura Tarihi</div>,
          dataIndex: 'InvoiceDate',
          key: 'InvoiceDate',
          align: 'center',
          render: (text, row) => (
            <span className="table-title-calibri-bold-12">
              {row.InvoiceDate ? dayjs(row.InvoiceDate).format('DD.MM.YYYY') : ''}
            </span>
          ),
        },
      ],
      partialColumns: [
        {
          title: <div className="table-title-calibri-bold-12">Takip No / İlişkili Fatura No</div>,
          dataIndex: 'TakipNo',
          key: 'TakipNo',
          width: 340,
          render: (text, row) => (
            <span className="table-title-calibri-bold-12">
              {row.TakipNo ? row.TakipNo : ''} -{' '}
              {row.RelatedInvoiceNumber ? row.RelatedInvoiceNumber : ''}
            </span>
          ),
        },
        {
          title: (
            <div className="table-title-calibri-bold-12">Şube - Merkez / Şube No / Şube Adı</div>
          ),
          dataIndex: 'SubeOrMerkez',
          key: 'SubeOrMerkez',
          width: 260,
          render: (text, row) => (
            <span className="table-title-calibri-bold-12">
              {row.SubeOrMerkez ? row.SubeOrMerkez : ''} - {row.BranchId ? row.BranchId : ''} -{' '}
              {row.BranchName ? row.BranchName : ''}
            </span>
          ),
        },
        {
          title: <div className="table-title-calibri-bold-12">Fatura Tarihi</div>,
          dataIndex: 'InvoiceDate',
          key: 'InvoiceDate',
          width: 150,
          render: (text, row) => (
            <span>
              {row.InvoiceDate ? dayjs(row.InvoiceDate).format('DD.MM.YYYY hh:mm:ss') : ''}
            </span>
          ),
        },
        {
          title: <div className="table-title-calibri-bold-12">Fatura Tutarı</div>,
          dataIndex: 'InvoiceAmount',
          key: 'InvoiceAmount',
          width: 150,
          render: (text, row) => (
            <span className="table-title-calibri-bold-12">
              {row.InvoiceAmount ? formatMoney(row.InvoiceAmount) : ''} TL
            </span>
          ),
        },
        {
          title: <div className="table-title-calibri-bold-12">Fatura No / Fatura Türü</div>,
          dataIndex: 'InvoiceNumber',
          key: 'InvoiceNumber',
          width: 200,
          render: (text, row) => (
            <span className="table-title-calibri-bold-12">
              {row.InvoiceNumber ? row.InvoiceNumber : ''} -{' '}
              {row.InvoiceType ? row.InvoiceType : ''}
            </span>
          ),
        },
      ],
    };
  }

  componentDidMount() {
    this.getInvoices();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState?.currentMerch?.number !== this.context?.selectedMerch?.number &&
      this.state?.currentMerch?.number === prevState.currentMerch?.number
    ) {
      this.getInvoices();
    }
  }

  getInvoices = () => {
    this.setState({ loading: true, currentMerch: this.context?.selectedMerch }, async () => {
      const { currentMerch } = this.state;
      if (currentMerch?.number) {
        try {
          const { payload } = await dashboardService.getDashboardPayeInvoices(currentMerch?.number);
          this.setState({ data: payload, loading: false });
        } catch (error) {
          notification.error({
            message: 'İşlem Başarısız!',
            description: error,
          });
          this.setState({ loading: false });
        }
      }
    });
  };

  handleCloseForm = () => {
    this.setState({ modalVisible: false, partialReports: [] });
  };

  render() {
    const { columns, data, loading, partialColumns, partialReports, modalVisible } = this.state;

    return (
      <>
        <PageContainer
          title="Paye Tarafından Kesilen Faturalar"
          footer={[
            <div
              key="footer-link"
              style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}
            >
              <NavLink to="/odemeler-ve-faturalar/paye-tarafindan-kesilen-faturalar">
                <span style={{ color: 'blue', fontSize: 15 }}>
                  Paye Tarafından Kesilen Faturalar{' '}
                </span>
              </NavLink>
            </div>,
          ]}
        >
          <Table
            loading={loading}
            dataSource={data}
            columns={columns}
            pagination={false}
            rowKey={(record, index) => index}
          />
        </PageContainer>

        <Modal
          width={1400}
          open={modalVisible}
          footer={false}
          title="Paye Tarafından Kesilen Faturalar"
          onCancel={this.handleCloseForm}
          destroyOnClose
        >
          <Table
            loading={loading}
            dataSource={partialReports}
            columns={partialColumns}
            pagination
            rowKey={(record, index) => index}
          />
        </Modal>
      </>
    );
  }
}

PayeInvoices.contextType = AuthContext;
export default PayeInvoices;
